import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledPage = styled.div`
  .layout {
    min-height: 100vh;
  }

  .pointer {
    cursor: pointer;
  }

  .pagination {
    margin-left: auto;
  }
  
  .action {
    color: #065f46;
  }

  .action .anticon-down {
    color: black;
  }

  .ant-pagination-item-active {
    border-color: ${(props) => props.theme.colorPaginationActiveBorder};
    border-width: 1px;
  }

  .month-picker .ant-picker-header {
    display: none !important;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-layout-content {
      background-color: ${(props) => props.theme.brand01};
    }
  }
`;
